import React from "react";
import SecuritySection from "../SecuritySection";

const WhyUsSection = () => {
  return (
    <div
      className="relative bg-cover bg-center  text-white py-36 px-4 my-12 rounded-3xl"
      style={{
        backgroundImage: "url('/assests/images/LandingPage/bg-Img22.webp')",
      }}
    >
      <div className="xl:max-w-5xl mx-auto">
        {/* Title Section */}

        <h2 className="text-4xl text-center md:text-start font-bold mb-6">
          Why Us?
        </h2>

        <p className="text-lg text-white mb-12 md:w-6/12">
          Discover what sets us apart. From tailored solutions, exceptional
          support to cutting-edge technology and a commitment to your success,
          we provide everything you need to achieve your goals with confidence.
        </p>

        {/* acc to new design */}
        {/* <div className="text-center mb-10">
          <button className="text-sm px-3 py-1 bg-gray-100 text-black rounded-full mb-3">
            Why Us
          </button>
          <h2 className="text-4xl md:text-5xl font-bold mb-2">
            Why our clients choose us{" "}
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto">
            Discover what sets us apart. From tailored solutions, exceptional
            support to cutting-edge technology and a commitment to your success,
            we provide everything you need to achieve your goals
            with confidence.
          </p>
        </div> */}

        {/* Cards Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Card 1 */}
          <div className=" p-6 rounded-lg border border-gray-500">
            <div className="mb-4">
              <img
                src="/assests/images/LandingPage/whyUsImg1.webp"
                alt="whyus2"
                className=" w-10 h-10"
              />
            </div>
            <h3 className="text-md font-semibold mb-2">Transparency</h3>
            <p className="text-white">
              Our platform provides a birds eye view of your campaign, offering
              real-time insights and automated work flows.
            </p>
          </div>
          {/* Card 2 */}
          <div className="border border-gray-500 p-6 rounded-lg">
            <div className="mb-4">
              <img
                src="/assests/images/LandingPage/whyUsImg2.webp"
                alt="whyus2"
                className=" w-10 h-10"
              />
              {/* <i className="text-3xl">📈</i> */}
            </div>
            <h3 className="text-md font-semibold mb-2">
              Cost and Time Effective
            </h3>
            <p className="text-white">
              we value of your time and resources. That’s why our solutions are
              designed to maximize efficiency while minimizing costs
            </p>
          </div>
          {/* Card 3 */}
          <div className="border border-gray-500 p-6 rounded-lg">
            <div className="mb-4">
              <img
                src="/assests/images/LandingPage/whyUsImg3.webp"
                alt="whyus2"
                className=" w-10 h-10"
              />
            </div>
            <h3 className="text-md font-semibold mb-2">Dedicated Support</h3>
            <p className="text-white">
              You’ll be assigned a dedicated Account Manager who provides
              personalized support and prompt responses.
            </p>
          </div>
          {/* Card 4 */}
          <div className="border border-gray-500 p-6 rounded-lg">
            <div className="mb-4">
              <img
                src="/assests/images/LandingPage/whyUsImg4.webp"
                alt="whyus2"
                className=" w-10 h-10"
              />
            </div>
            <h3 className="text-md font-semibold mb-2">
              Security & Compliance
            </h3>
            <p className="text-white leading-normal">
              We are committed to protecting your data with advanced security
              measures and strict adherence to compliances.
            </p>
          </div>
        </div>
        {/* <SecuritySection /> */}
      </div>
    </div>
  );
};

export default WhyUsSection;
